import Splide from "@splidejs/splide";
import { debounceEvent, detectMobile} from '../../../js/utils';

export default class ProductSuggestion {
  constructor(carouselElement, container) {
    this.carouselId = carouselElement.getAttribute('id');
    this.carouselElement = carouselElement;
    this.container = container ? container : undefined;
    this.carouselHeadline = document.querySelectorAll('.swa-container--product-suggestion .swa-headlines');
  }

  toggleArrow(carousel) {
    // Depending on the list and slides per view, we display (or not) the arrows
    if ((carousel.splideList > carousel.slidesPerViewMobile && detectMobile()) ||
        (carousel.splideList > carousel.slidesPerViewDesktop && !detectMobile())) {
          carousel.splideArrowNext.classList.remove('swa-invisible');
          carousel.splideArrowPrev.classList.remove('swa-invisible');
    } else {
      carousel.splideArrowNext.classList.add('swa-invisible');
      carousel.splideArrowPrev.classList.add('swa-invisible');
    }
  }

  scrollObserver() {
    let productDetailsPage = document.querySelector('.page-productDetails2');
    let productDetailsPagePl = document.querySelector('.js-patternlab-swa-pdp');
    let headlineObserver;
    let carouselObserver;
    let options;
    let rootMargin;

    if (detectMobile()) {
      rootMargin = '0px 0px -4% 0px';
    }
    else {
      rootMargin = '0px 0px -8% 0px';
    }

    // only for PDP - the carousel should be loaded faster (SWANSL-29567)
    if (productDetailsPage || productDetailsPagePl) {
      options = {
        root: null,
        rootMargin: '0px 0px 8% 0px',
      };
    }
    else {
      options = {
        root: null,
        rootMargin: rootMargin,
      }
    };

    // Since the headline and the carousel are siblings, 2 Intersections Observers were needed
    if (this.carouselHeadline) {
      headlineObserver = new IntersectionObserver(this.headlineHandleIntersect, options);
      this.headlineObserver = headlineObserver
      this.carouselHeadline.forEach((headline) => {
        this.headlineObserver.observe(headline);
      })
    }

    carouselObserver = new IntersectionObserver(this.carouselHandleIntersect, options);
    this.carouselObserver = carouselObserver;
    this.carouselObserver.observe(document.querySelector(`#${this.carouselId}`));
  }

  headlineHandleIntersect(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let headline = entry.target;
        headline.style.animation = `fadeInSuggestionsCarousel .8s ease-in-out 0s 1 forwards`;
        observer.unobserve(entry.target);
      }
    });
  }

  carouselHandleIntersect(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delayItem = 300;
        let carousel = entry.target;
        let items = carousel.querySelectorAll('.swa-product-suggestion__item');
        let hintedHighlightItem = carousel.parentElement.querySelector('.swa-product-suggestion__hinted--highlight');
        let arrows = carousel.querySelector('.swa-product-suggestion__arrows');

        // In case we have a hinted highlighted item
        if (hintedHighlightItem) {
          hintedHighlightItem.style.animation = `fadeInSuggestionsCarousel .8s ease-in-out 0s 1 forwards`;
        }

        // Show the carousel items one after another, with a bit of delay
        items.forEach((item, index) => {
          setTimeout(() => {
            if (!item.classList.contains('swa-product-suggestion__item--animated')) {
              item.classList.add('swa-product-suggestion__item--animated');
            }
          }, index * delayItem);
        });

        // Show the arrows
        if (arrows) {
          arrows.style.animation = `fadeInSuggestionsCarousel .8s ease-in-out 0.4s 1 forwards `;
        }
        observer.unobserve(entry.target);
      }
    });
  }

  addWindowResizeListener(suggestionCarousel) {
    window.addEventListener(
      'resize',
      debounceEvent(() => {

        let currentIsMobile = detectMobile();
        if ((this.isMobile !== currentIsMobile) && this.isMobile) {
          // Refresh is needed since we have a different layout on mobile/destkop
          suggestionCarousel.refresh();
          this.toggleArrow(suggestionCarousel);
          this.carouselObserver.unobserve(document.querySelector(`#${this.carouselId}`));
          this.scrollObserver();
          this.toggleArrowsVisibility(suggestionCarousel);
          this.isMobile = !this.isMobile;
        } else if ((this.isMobile !== currentIsMobile) && !this.isMobile) {
          // Refresh is needed since we have a different layout on mobile/destkop
          suggestionCarousel.refresh();
          this.toggleArrow(suggestionCarousel);
          this.carouselObserver.unobserve(document.querySelector(`#${this.carouselId}`));
          this.scrollObserver();
          this.toggleArrowsVisibility(suggestionCarousel);
          this.isMobile = !this.isMobile;
        }
      }, 250)
    );
  }

  toggleArrowsVisibility(carousel) {
    const prevArrow = carousel.root.querySelector('.splide__arrow--prev');
    const nextArrow = carousel.root.querySelector('.splide__arrow--next');

    carousel.splideList = carousel.root.querySelectorAll('.splide__slide');

    if (!carousel.splideList.length) {
      return;
    }

    const firstSlide = carousel.splideList[0];
    const lastSlide = carousel.splideList[carousel.splideList.length - 1];

    prevArrow.classList.add('swa-hidden');

    if (detectMobile()) {
      if (carousel.splideList.length <= carousel.slidesPerViewMobile) {
        prevArrow.classList.add('swa-hidden');
        nextArrow.classList.add('swa-hidden');
      }
    } else {
      if (carousel.splideList.length <= carousel.slidesPerViewDesktop) {
        prevArrow.classList.add('swa-hidden');
        nextArrow.classList.add('swa-hidden');
      }
    }

    carousel.on('moved', (destIndex) => {
      if (firstSlide.classList.contains('is-visible')) {
        nextArrow.classList.remove('swa-hidden');
        prevArrow.classList.add('swa-hidden');
      }

      if (!firstSlide.classList.contains('is-visible') && !lastSlide.classList.contains('is-visible')) {
        nextArrow.classList.remove('swa-hidden');
        prevArrow.classList.remove('swa-hidden');
      }

      if (lastSlide.classList.contains('is-visible')) {
        nextArrow.classList.add('swa-hidden');
        prevArrow.classList.remove('swa-hidden');
      }
    });
  }

  init() {
    if (!this.carouselId) {
      return;
    };

    const carouselIdSlide = document.querySelectorAll(`#${this.carouselId} .splide__slide`);
    this.isMobile = detectMobile();

    // In order to access the suggestionCarousel, on different functions, create the splide carousel in init()
    // suggestionCarousel can now be accessed in addWindowResizeListener() and also, refresh() is now available

    let suggestionCarousel;
    let slidesPerViewMobile = this.carouselElement.dataset.slideStepMobile || 2;
    let slidesPerViewDesktop = this.carouselElement.dataset.slideStepDesktop || 4;
    let listLength = this.carouselElement.querySelectorAll(`#${this.carouselId} .splide__slide`).length;

    // We need the carousel to be type 'slide' with rewind 'true', and to mention the perPage values (without perMove!!! in this case)
    // By having those options, splide handles the case when the slides are not a multiple of slidesPerViewMobile/slidesPerViewDesktop and only moves fewer elements.
    // This creates the impression of a continous strip

    suggestionCarousel = new Splide(`#${this.carouselId}`, {
      rewindSpeed: 600,
      speed: 400,
      autoplay: false,
      pagination: false,
      startIndex: 0,
      perPage: parseInt(slidesPerViewDesktop),
      gap: '1rem',
      drag: this.carouselElement.classList.contains("swa-product-suggestion__hinted--carousel") ? (listLength <= 3 ? false : true) : (listLength <= 4 ? false : true),
      breakpoints: {
        1025: {
          perPage: parseInt(slidesPerViewMobile),
          drag: this.carouselElement.classList.contains("swa-product-suggestion__hinted--carousel") ? (listLength <= 1 ? false : true) : (listLength <= 2 ? false : true)
        }
      }
    });
    suggestionCarousel.mount();

    suggestionCarousel.splideArrowPrev = suggestionCarousel.root.querySelector('.splide__arrow--prev');
    suggestionCarousel.splideArrowNext = suggestionCarousel.root.querySelector('.splide__arrow--next');
    suggestionCarousel.splideList = suggestionCarousel.root.querySelectorAll(`#${this.carouselId} .splide__slide`).length;
    suggestionCarousel.slidesPerViewDesktop = suggestionCarousel.root.dataset.slideStepDesktop;
    suggestionCarousel.slidesPerViewMobile = suggestionCarousel.root.dataset.slideStepMobile;

    this.toggleArrowsVisibility(suggestionCarousel);
    this.toggleArrow(suggestionCarousel);
    this.scrollObserver();
    this.addWindowResizeListener(suggestionCarousel);
  }
}
